import { ref, onMounted, onUnmounted } from 'vue-demi';
export const makeUseInfiniteScroll = (options) => (domElRef) => {
    const pageRef = ref(1);
    let observer = void 0;
    onMounted(() => {
        observer = new IntersectionObserver(([domEl]) => {
            if (domEl === null || domEl === void 0 ? void 0 : domEl.isIntersecting) {
                pageRef.value++;
            }
        }, options !== null && options !== void 0 ? options : {});
        observer.observe(domElRef.value);
    });
    onUnmounted(() => {
        observer === null || observer === void 0 ? void 0 : observer.disconnect();
    });
    return pageRef;
};
